import React, { useContext } from 'react'
import { I18nextContext } from '@toasttab/shared/src/context/i18nextContext'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'
import { localizeLink } from '@toasttab/shared/src/utils/linkUtils'
import { FooterColumnProps } from './Footer.d'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'

const FooterContentColumn = ({
  footerLinkCss,
  hostName,
  menuItems,
  title
}: FooterColumnProps) => {
  const { t } = useI18next()
  const localizationContext = useContext(I18nextContext)

  return (
    <nav className='col-span-2 lg:col-span-1' data-testid='FooterContentColumn'>
      <Typography
        allowHtml={false}
        as='p'
        classes='text-default mb-6 text-base font-sansPro font-normal'
        variation='default'
      >
        {t(title)}
      </Typography>
      <ul>
        {menuItems.map((mi: any, j: number) => (
          <li
            className='mb-6'
            data-testid='FooterContentColumn-listItem'
            key={j}
          >
            {mi.href.startsWith('http') && (
              <a
                className={footerLinkCss}
                data-testid='FooterContentColumn-link-external'
                href={mi.href}
                rel='nofollow'
              >
                {t(mi.text)}
              </a>
            )}
            {!mi.href.startsWith('http') && !mi.href.startsWith('/') && (
              <a
                className={footerLinkCss}
                data-testid='FooterContentColumn-link-host'
                href={`${hostName}/${mi.href}`}
                rel='nofollow'
              >
                {t(mi.text)}
              </a>
            )}
            {mi.href.startsWith('/') && (
              <a
                className={footerLinkCss}
                data-testid='FooterContentColumn-link-local'
                href={localizeLink(
                  mi.href,
                  localizationContext.language,
                  localizationContext
                )}
              >
                {t(mi.text)}
              </a>
            )}
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default FooterContentColumn
